import { axios } from '@/utils/request'

const api = {
    options: '/adminapi/jiaolian/options',
    getApplyList: '/adminapi/jiaolian/shengJlManageList',
    manageEdit: '/adminapi/jiaolian/shengJlManageEdit',
    getMemberList: '/adminapi/jiaolian/shengJlList',
    refreshCert: '/adminapi/jiaolian/refreshCert',
    checkShengMemberOK: '/adminapi/jiaolian/checkShengMemberOK',
    shengjlApply: '/adminapi/jiaolian/shengjlApply',
    getShengShenheUrls: '/adminapi/jiaolian/getShengShenheUrls',
    shengapplydetail: '/adminapi/jiaolian/shengapplydetail',
    shengApplyDelete: '/adminapi/jiaolian/shengApplyDelete',
    jiaolianList: '/adminapi/jiaolian/jiaolianList',
    jiaolianDetail: '/adminapi/jiaolian/jiaoliandetail',
    shengJlDetail: '/adminapi/jiaolian/shengJlDetail',
    jiaolianEdit: '/adminapi/jiaolian/jiaolianedit',
    shengJlEdit: '/adminapi/jiaolian/shengJlEdit',
    jiaolianDelete: '/adminapi/jiaolian/jiaoliandelete',
    shengJlDelete: '/adminapi/jiaolian/shengJlDelete',
    shengJiaolianPrint: '/adminapi/jiaolian/shengJiaolianPrint',
}

export default api
export function shengJiaolianPrint(parameter) {
    return axios({
        url: api.shengJiaolianPrint,
        method: 'get',
        params: parameter
    })
}

export function getOptions(parameter) {
    return axios({
        url: api.options,
        method: 'get',
        params: parameter
    })
}
export function getApplyList(parameter) {
    return axios({
        url: api.getApplyList,
        method: 'post',
        data: parameter
    })
}


export function getJiaolianList(parameter) {
    return axios({
        url: api.jiaolianList,
        method: 'get',
        params: parameter
    })
}
export function getMemberList(parameter) {
    return axios({
        url: api.getMemberList,
        method: 'post',
        data: parameter
    })
}

export function refreshCert(parameter) {
    return axios({
        url: api.refreshCert,
        method: 'post',
        data: parameter
    })
}

export function getJiaolianDetail(parameter) {
    return axios({
        url: api.jiaolianDetail,
        method: 'get',
        params: parameter
    })
}
export function getShengJiaolianDetail(parameter) {
    return axios({
        url: api.shengJlDetail,
        method: 'get',
        params: parameter
    })
}
export function checkShengMemberOK(parameter) {
    return axios({
        url: api.checkShengMemberOK,
        method: 'post',
        data: parameter
    })
}

export function editJiaolian(parameter) {
    return axios({
        url: api.jiaolianEdit,
        method: 'post',
        data: parameter
    })
}
export function editShengJiaolian(parameter) {
    return axios({
        url: api.shengJlEdit,
        method: 'post',
        data: parameter
    })
}
export function editShengJlManage(parameter) {
    return axios({
        url: api.manageEdit,
        method: 'post',
        data: parameter
    })
}
export function shengjlApply(parameter) {
    return axios({
        url: api.shengjlApply,
        method: 'post',
        data: parameter
    })
}
export function getShengShenheUrls(parameter) {
    return axios({
        url: api.getShengShenheUrls,
        method: 'post',
        data: parameter
    })
}
export function getShengApplyDetail(parameter) {
    return axios({
        url: api.shengapplydetail,
        method: 'post',
        data: parameter
    })
}
export function shengApplyDelete(parameter) {
    return axios({
        url: api.shengApplyDelete,
        method: 'post',
        data: parameter
    })
}

export function deleteJiaolian(parameter) {
    return axios({
        url: api.jiaolianDelete,
        method: 'post',
        data: parameter
    })
}

export function deleteShengJl(parameter) {
    return axios({
        url: api.shengJlDelete,
        method: 'post',
        data: parameter
    })
}